<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <!-- <p>{{ voice_list }}</p> -->
    <div class="voice-list">
      <div v-for="item in voice_list" :key="item.id" class="voice-item">
        <p>{{ item.name }}</p>
        <audio
          auto
          controls
          v-if="item.voice_src"
          :src="item.voice_src"
        ></audio>
      </div>
    </div>
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["voice_list", "dialogVisible", "title"],
  // data() {
  //   return {};
  // },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__body {
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
.voice-list {
  .voice-item {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    audio {
      height: 54px;
    }
    p {
      line-height: 54px;
      margin-right: 20px;
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/VoiceShow.vue